import React from "react";
import { oneOf, string } from "prop-types";

import Icon from "../../icons";

import "./social-auth-button.m.css";

const SocialAuthButton = ({ type, className, href }) => {
  return (
    <a styleName={`${type}-wrapper`} className={className} href={href}>
      {type === "fb" ? <Icon type="fb-blue" className="fb-blue" /> : <div styleName="google-icon" />}
      <div styleName="title-wrapper">
        <span styleName="with">WITH</span>
        <span styleName="title">{type === "fb" ? "FACEBOOK" : "GOOGLE"}</span>
      </div>
    </a>
  );
};

SocialAuthButton.propTypes = {
  href: string,
  type: oneOf(["google", "fb"]),
  className: string
};

export default SocialAuthButton;
